<template>
  <div>
    <div v-show="radio == '1'">
      <div class="pop_content" v-show="clauseIndex == 1">
        <h3 style="text-align: center">
          安诚财产保险股份有限公司河北分公司投标保证金保险投保须知
        </h3>
        <p>一、保函/保险凭证保险责任：</p>
        <p>（一）投标人在投标有效期内撤销、撤回或者修改其投标文件的；</p>
        <p>
          （二）投标人在收到中标通知书后，非因不可抗力原因放弃中标，无正当理由不与招标人订立合同的；
        </p>
        <p>
          （三）投标人在在收到中标通知书后，不按照招标文件要求提交履约担保的。
        </p>
        <p>
          二、投保流程：保函/保险凭证全程线上申请，依据系统步骤填写投保单、确认信息、支付保费后即可出具保函/保险凭证并自行下载、预览和查看详情。
        </p>
        <p>三、投保咨询客服热线：95544</p>
        <p>四、发票出具：</p>
        <p>（一）电子普票：投保人在线上申请后可直接在线下载；</p>
        <p>
          （二）纸质专票：投保人在线上申请后，保险人会在10个工作日内寄出，快递为顺丰到付。
        </p>
        <p style="font-size: 14px; text-align: end; font-weight: bold">
          安诚财产保险股份有限公司河北分公司
        </p>
        <h3 style="text-align: center; margin-top: 30px">
          安诚财产保险股份有限公司河北分公司投标保证金保险退保须知
        </h3>
        <p>
          一、保函/保险凭证退保处理为线上申请，线下办理，满足以下条件可进行退保申请：
        </p>
        <p>
          （一）开标前投保人自愿放弃投保或项目发生中止、暂停的，可进行退保（开标前1个工作日无法申请退保）；
        </p>
        <p>（二）项目发生流标、终止的，可进行退保；</p>
        <p>（三）开标后项目发生流标的，可进行退保；</p>
        <p>（四）除上述3种情形外均不予退保；</p>
        <p>（五）投保人办理退保事宜，满足退保条件的，保险费全额退还。</p>
        <p>二、退保所需材料：</p>
        <p>（一）投保人盖章退保申请；</p>
        <p>（二）保费退回的账户信息；</p>
        <p>（三）投保人公司的营业执照。</p>
        <p>三、退保办理服务热线：0311-68121309，联系人：张闪</p>
        <p style="font-size: 14px; text-align: end; font-weight: bold">
          安诚财产保险股份有限公司河北分公司
        </p>
      </div>
      <!-- 保险条款 -->
      <div class="pop_content" v-show="clauseIndex == 2">
        <h3 style="text-align: center">
          安诚财产保险股份有限公司
        </h3>
        <h3 style="text-align: center">
          建设工程施工合同投标保证保险（一年期）条款
        </h3>
        <p class="min_title">总则</p>
        <p> 第一条<span></span>本保险合同由保险条款、投保单、保险单、保险凭证以及批单组成。凡涉及本保险合同的约定，均应采用书面形式。</p>
        <p>&nbsp</p>
        <p>
          第二条<span></span>本保险合同的投保人是指依据中华人民共和国法律（不包括香港、澳门及台湾地区法律，下同）及《建设工程招标文件》的要求向建设工程招标人投标、中标，与招标人签订《建设工程施工合同》的，具有相应工程施工承包资质的当事人，即建设工程投标人、
          中标人。</p>
        <p>&nbsp</p>
        <p>第三条<span></span>本保险合同的被保险人是指依法及《建设工程招标文件》的要求向建设工程施工投标人进行建设工程招标、确定中标人、与中标人签订《建设工程施工合同》的当事人， 即建设工程招标人。</p>
        <p>&nbsp</p>
        <p>第四条<span></span>投保人不得将本保险合同项下的权利转让或设定担保。</p>
        <p class="min_title">保险责任</p>
        <p>第五条<span></span>根据《中华人民共和国招标投标法》及《中华人民共和国招标投标法实施条例》， 在保险期间内，投保人在向被保险人招标建设工程投标的过程中，因下列情形之一：</p>
        <p>（一）投标截止后投保人未经被保险人同意或者违反《建设工程招标文件》撤销投标文件；</p>
        <p>（二）投保人与其他投标人相互串通投标；</p>
        <p>（三）投保人弄虚作假行为；</p>
        <p>（四）中标后未按《建设工程招标文件》的要求签署《建设工程施工合同》；</p>
        <p>（五）中标后未按《建设工程招标文件》规定的时间提交履约保函；</p>
        <p>（六）《建设工程招标文件》规定的其他有关投标实质性违约情形；</p>
        <p>给被保险人造成经济损失的，被保险人向保险人提出索赔，保险人依据本保险合同的约定，在投标保证保险责任范围和投标保证保险金额内对被保险人的上述损失承担赔偿责任。</p>
        <p class="min_title">责任免除</p>
        <p>第六条<span></span>出现下列任一情形时，保险人不承担赔偿保险金的责任：</p>
        <p>（一）被保险人的招标行为本身违反《中华人民共和国招标投标法》等有关规定的。</p>
        <p>（二）被保险人未履行《建设工程招标文件》条款规定义务的；</p>
        <p>（三）被保险人实质变更《建设工程招标文件》，增加保险人责任，未经保险人书面同 意或确认的，损害保险人利益的；</p>
        <p>（四）被保险人或其代表与投保人串通投标、被保险人或其代表参与弄虚作假的；</p>
        <p>（五）其他不可归责于投保人的情形。</p>
        <p>&nbsp</p>
        <p>第七条<span></span>下列原因造成的损失、费用和责任，保险人不负责赔偿：</p>
        <p>（一）战争、敌对行动、军事行为、武装冲突、罢工、骚乱、暴动、恐怖活动或恐怖 袭击；</p>
        <p>（二）核辐射、核爆炸、核污染及其他放射性污染；</p>
        <p>（三）大气污染、土地污染、水污染及其他各种污染；</p>
        <p>（四）政府征用、行政行为或司法行为；</p>
        <p>（五）洪水、台风、地震、海啸等自然灾害及次生灾害。</p>
        <p>&nbsp</p>
        <p>第八条 <span></span>下列损失、费用和责任，保险人不负责赔偿：</p>
        <p>（一）按本保险合同中载明的免赔率（额）计算的免赔额</p>
        <p>（二）被保险人以外的第三人的任何损失；</p>
        <p>（三）罚款、罚金及惩罚性赔偿；</p>
        <p>（四）其他不属于本保险责任范围内的损失、费用和责任。</p>
        <p class="min_title">保险金额和免赔率</p>
        <p>第九条 <span></span>本保险合同的保险金额以《建设工程招标文件》的有关要求为基础，通过投保人与保险人协商确定，并在保险合同中载明。</p>
        <p>&nbsp</p>
        <p>第十条 <span></span>每次保险事故免赔率（额）由投保人与保险人在签订保险合同时协商确定，并在保险合同中载明。</p>
        <p class="min_title">保险期间</p>
        <p> 第十一条<span></span>
          本保险合同保险期间，最长不超过一年，以《建设工程招标文件》对投标有效期的要求为基础确定。自投保人向被保险人投标之日起或保险单载明的保险起期之日起（二者以后发生者为准），至《建设工程施工合同》签约之日或保险单载明的保险终期之日止（二者以先到者为准）。
        </p>
        <p>本保险合同保险期间届满或提前终止，被保险人应立即将本保险合同原件退还保险人， 被保险人未履行此义务，本保险合同仍在保险期间届满或提前终止之日失效。</p>
        <p class="min_title">保险费</p>
        <p>第十二条 <span></span>本保险合同的保险费由保险人根据投保人企业经营情况、保险金额、风险控制等因素确定，并在保险单上载明其金额。</p>
        <p class="min_title">保险人义务</p>
        <p>第十三条 <span></span>订立本保险合同时，采用保险人提供的格式条款的，保险人向投保人提供的投保单应当附格式条款，保险人应当向投保人说明本保险合同的内容。对本保险合同中免除
          保险人责任的条款，保险人在订立本保险合同时应当在投保单、保险单或者其他保险凭证上 作出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人作出明确 说明；未作提示或者明确说明的，该条款不产生效力。
        </p>
        <p>&nbsp</p>
        <p>第十四条 <span></span>本保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭证。</p>
        <p>&nbsp</p>
        <p> 第十五条 <span></span>保险人按照本保险合同的约定，认为被保险人提供的有关索赔的证明和资料不完整的，应当及时一次性通知投保人、被保险人补充提供。</p>
        <p>&nbsp</p>
        <p>第十六条 <span></span>保险人收到被保险人的赔偿保险金的请求后，应当及时作出是否属于保险责任的核定；情形复杂的，应当在三十日内作出核定，但本保险合同另有约定的除外。</p>
        <p>
          保险人应当将核定结果通知被保险人；对属于保险责任的，在与被保险人达成赔偿保险金的协议后十日内，履行赔偿保险金义务。本保险合同对赔偿保险金的期限有约定的，保险人应当按照约定履行赔偿保险金的义务。保险人依照前款约定作出核定后，对不属于保险责任的，应当自作出核定之日起三日内向被保险人发出拒绝赔偿保险金通知书，并说明理由。
        </p>
        <p>&nbsp</p>
        <p>第十七条 <span></span>保险人自收到赔偿保险金的请求和有关证明、资料之日起六十日内，对其赔偿保险金的数额不能确定的，应当根据已有证明和资料可以确定的数额先予支付；保险人最
          终确定赔偿的数额后，应当支付相应的差额。</p>
        <p class="min_title">投保人、被保险人义务</p>
        <p>第十八条<span></span> 订立本保险合同，投保人应如实填写投保单，保险人就投保风险的有关情况以及投保人、被保险人的有关情况提出询问的，投保人应当如实告知，并提供保险人要求的
          必要证明材料，接受保险人对其资质进行审查。</p>
        <p>&nbsp</p>
        <p>第十九条 <span></span>除本保险合同另有约定外，投保人应当在本保险合同成立时一次性交清本保险合同约定的全部保险费，同时有义务应保险人之要求提供反担保。投保人未按约定交付保
          险费并提供反担保的，保险合同不生效。</p>
        <p>&nbsp</p>
        <p> 第二十条<span></span> 被保险人应当遵守国家有关消防、安全、生产操作、劳动保护等方面的规定， 维护保险标的的安全。保险人可以按照合同约定对保险标的的安全状况进行检查，及时向
          投保人、被保险人提出消除不安全因素和隐患的书面建议。投保人、被保险人未按照约定 履行其对保险标的的安全应尽责任的，保险人有权要求增加保险费或者解除合同。保险人
          为维护保险标的的安全，经被保险人同意，可以采取安全预防措施。</p>
        <p>&nbsp</p>
        <p>第二十一条 <span></span>保险期间内，如保险合同存在担保权利的，未经保险人书面同意，投保人、被保险人不得以任何形式撤销、放弃、转让相应的保证、抵押或质押等担保权利，也不得 以任何形式影响上述权利的效力。
        </p>
        <p>如投保人、被保险人未遵守上述约定而导致的损失，保险人不承担赔偿责任。</p>
        <p>第二十二条 <span></span>在保险期间内，被保险人应及时检查并协助保险人了解招投标和《建设工程施工合同》签订进程，被保险人如发现投保人存在违约风险，或有任何其他可能导致本保
          险合同风险显著增加的情况，被保险人应采取措施降低或消除上述风险，并及时书面通知保险人。</p>
        <p>&nbsp</p>
        <p> 第二十三条 <span></span>知道保险事故发生后：</p>
        <p>（一）被保险人应该尽力采取必要、合理的措施，防止或减少损失，否则，对因此扩大 的损失，保险人不负责赔偿。</p>
        <p>（二）投保人、被保险人应及时通知保险人，并书面说明事故发生的原因、经过、损 失情况和处理情况；故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失
          程度等难以确定的，保险人对无法确定的部分，不承担赔偿责任，但保险人通过其他途径 已经及时知道或者应当及时知道保险事故发生的除外。</p>
        <p>（三）被保险人应完整保留与投保人在招投标和《建设工程施工合同》订立过程中形成 的有关的文件（中标通知书、投标函及其附录、招标文件等），允许并且协助保险人对事故进行调查。</p>
        <p>&nbsp</p>
        <p>第二十四条 <span></span>被保险人提出索赔申请时，应向保险人提供下列书面证明和资料：</p>
        <p>（一）索赔申请书；</p>
        <p>（二）保险凭证；</p>
        <p>（三）《建设工程招标文件》副本；</p>
        <p>（四）与招投标及合同签订有关的所有文件；</p>
        <p>（五）投保人、被保险人所能提供的与确认保险事故的性质、原因、损失程度等有关的 其他证明和资料；</p>
        <p>被保险人未履行前款约定的索赔材料提供义务，导致保险人无法核实损失情况的，保险人对无法核实的部分不承担赔偿责任。</p>
        <p class="min_title">赔偿处理</p>
        <p>第二十五条 <span></span>保险人的赔偿以下列方式之一确定的投保人的赔偿责任为基础：</p>
        <p>（一）投保人、被保险人之间协商并经保险人确认；</p>
        <p>（二）仲裁机构裁决；</p>
        <p>（三）人民法院判决；</p>
        <p>（四）保险人认可的其他方式。</p>
        <p>第二十六条 <span></span>被保险人发生保险责任范围内的损失，保险人按以下方式计算赔偿金额： 赔偿金额=保险损失×(1-免赔率）或赔偿金额=保险损失-免赔额，赔偿金额应分项计算，每项赔偿金额≤分项保险金额。
        </p>
        <p>&nbsp</p>
        <p>第二十七条 <span></span>发生保险事故时，如果存在重复保险的情况，则本保险人按照本保险合同的保险金额与其他保险合同及本合同的保险金额总和的比例承担赔偿责任。</p>
        <p>其他保险人应承担的赔偿金额，本保险人不负责垫付。若被保险人未如实告知导致保 险人多支付赔偿金的，保险人有权向被保险人追回多支付的部分</p>
        <p>第二十八条 <span></span>发生保险责任范围内的损失，保险人自向被保险人赔偿保险金之日起，在赔偿金额范围内代位行使被保险人对投保人或其担保人（如有）请求赔偿的权利，被保险
          人应当向保险人提供必要的文件和所知道的有关情况，积极协助保险人向投保人或其担保 人（如有）进行追偿。</p>
        <p>&nbsp</p>
        <p> 被保险人已经从投保人或其担保人（如有）处取得赔偿的，保险人赔偿保险金时，应 相应扣减被保险人已从投保人或其担保人（如有）处取得的赔偿金额。</p>
        <p>第二十九条 <span></span>保险事故发生后，在保险人未赔偿保险金之前，被保险人放弃对投保人或其担保人（如有）请求赔偿权利的，保险人不承担赔偿责任；保险人向被保险人赔偿保险
          金后，被保险人未经保险人同意放弃对投保人或其担保人（如有）请求赔偿权利的，该行为无效；由于被保险人故意或者因重大过失致使保险人不能行使追偿的权利的，保险人可 以扣减或者要求返还相应的保险金。</p>
        <p>&nbsp</p>
        <p>第三十条 <span></span>发生保险事故且保险人赔偿后，保险人有权处置投保人提供的反担保，同时对不足清偿保险人赔款的部分，有权根据本保险合同第二十八条继续向投保人或者担保人 进行追偿。</p>
        <p>&nbsp</p>
        <p>第三十一条 <span></span>被保险人向保险人请求赔偿保险金的诉讼时效期间为二年，自其知道或者应当知道保险事故发生之日起计算。</p>
        <p class="min_title">争议处理与法律适用</p>
        <p>第三十二条 <span></span>因履行本保险合同发生的争议，由当事人协商解决。协商不成的，提交保险单载明的仲裁机构仲裁；保险单未载明仲裁机构且争议发生后未达成仲裁协议的，依法向 中华人民共和国人民法院起诉。
        </p>
        <p> 本保险合同争议处理适用中华人民共和国法律（不包括港澳台地区法律）。</p>
        <p class="min_title">其他事项</p>
        <p>第三十三条 <span></span>在本保险合同载明的保险起期之日前，投保人要求解除保险合同的，保险人在扣除
          5%手续费后退还已收取的保险费，但投保人应向保险人退还保险单、保险凭证以及与保险单相关资料的原件。本保险合同自保险人收到申请时终止。</p>
        <p>在保险单中载明的保险起期之日后，未经被保险人书面同意，投保人不得要求解除保 险合同。经被保险人书面同意解除保险合同的，保险人按日收取自保险起期之日起至保险
          合同解除之日应收的保险费，并退还剩余部分保险费。本保险合同自保险人收到投保人申 请和被保险人书面证明时终止。</p>
        <p class="min_title">释义</p>
        <p> 第三十四条 <span></span>本保险合同涉及下列术语时，适用下列释义：</p>
        <p>1. 《建设工程招标文件》：是指按照《中华人民共和国建筑法》、《中华人民共和国招标投标法》等法律法规的要求，在建设工程招投标过程中由发包方出具的对合同当事人均具有约 束力的文件。</p>
        <p> 2. 《建设工程施工合同》：是指根据法律规定和合同当事人约定具有约束力的文件，构成合同的文件包括合同协议书、中标通知书（如果有）、投标函及其附录（如果有）、专用合同
          条款及其附件、通用合同条款、技术标准和要求、图纸、已标价工程量清单或预算书以及其 他合同文件。</p>
        <p> 2.1 合同协议书：是指构成合同的由发包人（被保险人）和承包人（投保人）共同签署的称为“合同协议书”的书面文件。</p>
        <p>2.2 中标通知书：是指构成合同的由发包人通知承包人中标的书面文件。</p>
        <p>2.3 投标函：是指构成合同的由承包人填写并签署的用于投标的称为“投标函”的文件。</p>
        <p>2.4 投标函附录：是指构成合同的附在投标函后的称为“投标函附录”的文件。</p>
        <p>3．日期和期限</p>
        <p>除特别指明外，均指日历天。保险合同中按天计算时间，签署保单当天不计入，从次日 开始计算，期限最后一天的截止时间为当天24:00时</p>
        <p>4．《建设工程招标文件》的实质变更</p>
        <p>变更《建设工程招标文件》中以下内容，构成实质变更：</p>
        <p>（1） 关于工程施工内容及范围的约定；</p>
        <p>（2） 关于施工质量的约定；</p>
        <p>（3） 关于合同价款的约定；</p>
        <p>（4） 关于工程款支付及工程结算的约定；</p>
        <p>（5） 关于工程索赔的约定；</p>
        <p>（6） 关于履行期间的约定（包括开工时间、完工时间、施工进度、竣工时间、交付竣工资料的时间、保修期等）；</p>
        <p>（7） 关于违约责任和解决争议的约定；</p>
        <p>（8） 合同成立的时间与地点。</p>
        <p>5．每次保险事故：是指投保人基于同一近因，在保险责任范围内给被保险人造成的一系列直接经济损失，本保险合同将其视为一次保险事故，每一次保险事故在本保险合同中简
          称为每次保险事故。其中近因是指发生事故造成损失的最直接、最有效并起主导作用或支配 作用的原因。</p>
      </div>
      <!-- 特别约定 -->
      <div class="pop_content" v-show="clauseIndex == 3">
        <h3 style="text-align: center">特别约定</h3>
        <p>1.尊敬的客户，投保次日起，您可以通过我司官方网站、客服电话、营业网点核实保单及理赔等信息。若对查询结果有异议，请联系本公司。官方网站：http://www.e-acic.com电话：95544。</p>
        <p>2.本公司偿付能力数据请参见公司官方网站www.e-acic.com中“公开信息披露”栏，本公司偿付能力充足率符合监管规定。</p>
        <p>3.本保险适用条款《建设工程施工合同投标保证保险（一年期）》(安诚财险)(备-保证保险)【2020】(主)021 号。</p>
      </div>
      <!-- 特别约定 -->
      <div class="pop_content" v-show="clauseIndex == 4">
        <h3 style="text-align: center">安诚财产保险股份有限公司</h3>
        <h3 style="text-align: center">隐私协议（2022年版）</h3>
        <p style="text-indent: 0;">尊敬的客户：</p>
        <p>1.本隐私协议由安诚财产保险股份有限公司（以下简称“我方”）提供，适用于我方所提供的各类保险产品及服务，以及其他增值服务（以下统称“我们的产品及服务”）。</p>
        <p>
          2.我方按照法律规定、监管要求及本协议约定收集、处理您的个人信息。本协议可能涉及您个人信息权益的重要约定，我方对与您的权益有重大关系的条款已采用加粗方式标注，请您在提供个人信息前仔细阅读。一旦您在本协议上签字，即视为您同意本协议的全部内容。
        </p>
        <p>3.为进一步向您提供我们的产品及服务，需要您提供以下相关信息：</p>
        <p>
          （1）常用信息：投保人信息（包括姓名、证件类型、证件号码、性别、职业类别、常驻城市、是否仅为中国税收居民、国籍、联系方式及地址、证件有效期），被保险人信息（包括姓名、证件类型、证件号码、性别、出生日期、与投保人关系、是否仅为中国税收居民、国籍、职业类别、证件有效期、学校全称、班级）等。
        </p>
        <p>
          （2）车险产品投保所需信息：机动车所有人或者管理人信息（包括姓名、证件类型、证件号码、性别、国籍、联系电话及地址、证件有效期）、驾驶证、行驶证、机动车种类、使用性质、车牌号、发动机号、识别代码（车架号）、厂牌型号、排量、功率、能源种类（如为新能源车，包含充电桩信息）、登记日期、发证日期、核定载客人员数或核定载质量、车船税信息（包括纳税人识别号、完税信息、完税/减免税凭证号、纳税金额、减免税金额、开具税务机关名称）、交强险保险期间、商业险保险期间、被保险人与机动车的关系、商业险投保险种名称及保（限）额、是否为贷款车、是否为过户车、是否为新车未上牌等。
        </p>
        <p>
          （3）非车险产品投保（包括企业财产保险、普通家财保险、普通意外保险、普通健康保险、责任保险）所需信息：保险方案、生效时间、截止时间、投保金额、身故受益人信息、财产标的、厂牌型号、企业信息（包括企业名称、所属行业、营业执照号码、联系电话、财产所在城市、财产标的详细地址、房屋面积、房屋数量、房屋结构）等。
        </p>
        <p>（4）理赔服务所需信息：投保人信息、被保险人信息、驾驶证、行驶证、银行卡信息、个人健康生理信息（住院单、医嘱单、检测报告、护理记录、用药记录）等。</p>
        <p>
          4.您同意在法律法规及监管规定允许的范围内，根据与我方签订的保险合同之需要，从我方内部及我方授权的第三方合作机构查询和收集您提供的上述信息；您授权我方在依据行业监管及为实现服务目的之需要而向其他机构进行必要的合作的前提下对上述信息进行合理使用及信息共享（包括但不限于：因保险监督管理及风险控制之需要而进行的行业内信息分享；因信息数据使用、储存、下载之需要而与第三方合作机构进行的数据互通；为提高保险服务水平之需要而与医疗卫生和健康管理机构进行的诊疗信息和健康记录的查询和共享；为公共服务之需要与其他政府机构、监管部门、司法机关及第三方信息信用平台进行的信息共享等）。
        </p>
        <p> 5.若您是未满18周岁的未成年人，请在您的父母或其他监护人监护、指导下共同阅读本协议。</p>
        <p>6.如您有任何建议、咨询或投诉，或法律法规规定的其他权利请求，请通过我方客户服务电话95544与我方联系。</p>
        <p>
          本人同意安诚财产保险股份有限公司向行政司法机关、医疗机构、单位和个人检索、调阅、摘抄、复印或其他方式获取任何与本人本保险合同相关的资料。本人谨此授权凡知道或拥有任何有关本人本保险合同相关情况的任何行政司法机关、单位、医疗机构或个人，均可将有关资料提供给安诚财产保险股份有限公司。本人愿意承担由此产生的一切法律责任，此授权书的影印本也同样有效。
        </p>
        <p style="text-indent: 0;">客户（或其他法定监护人）签字： </p>
      </div>
    </div>
    <div style="
                overflow: hidden;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
              " v-show="radio == '2'">
      <!-- 投保须知 -->
      <div class="pop_content" v-show="clauseIndex == 1">
        <h3 style="text-align: center">
          投保须知
        </h3>
        <p>1、请详细审阅投保须知内容,相关条款、特别是保险责任、责任免除、特别约定和合同解除等事宜；</p>
        <p>2、合同解除：除投保人与保险人另有约定，保险责任开始前，投保人要求解除保险合同的，保险人可以退还保险费，保险责任开始后，保险合同当事人不得解除保险合同。</p>
        <p>
          3、收到本保险单后,请您详细核对，如有错误或与投保单事实不符，请您在三个工作日内通知保险人进行书面批改更正，其他方式的更改无效;
        </p>
        <p>
          4、保险单所记载事项如发生变化，请立即向保险人申请办理批改手续，否则，保险人对由此造成的任何后果不负责任；
        </p>
        <p>
          5、保单查询方式提示：本保验单自签发之日起可拨打全民统一客服专线95569/4008095569查询保险单信息;并可进入公司官网http://e.djbx.com,点击官网首页“保单查询”一服务中心“信用险保单查询”，输入保险单号及投保人统一社会信用代码即可查询保险单信息；
        </p>
        <p>6、本产品保障区域为中华人民共和国境内（不含港澳台)；</p>
        <p>7、本产品由大家财产保险有限责任公司承保，东方大地(武汉)保险经纪有限公司协助办理保险业务；</p>
        <p>8、本保单适用条款为《大家财产保险有限责任公司投标保证保险条款》（注册号：C00024231412022081117903）</p>
      </div>
      <!-- 保险条款 -->
      <div class="pop_content" v-show="clauseIndex == 2">
        <h3 style="text-align: center">
          大家财产保险有限责任公司
        </h3>
        <h3 style="text-align: center">
          投标保证保险条款
        </h3>
        <h3 style="text-align: center">
          大家财产保险有限责任公司（注册号：C00024231412022081117903）
        </h3>
        <p class="min_title">总则</p>
        <p> 第一条 <span></span>本保险合同由保险条款、投保单、保险单、保险凭证等组成。凡涉及本保险合同的约定、通知、文件等，均采用书面形式。</p>
        <p>&nbsp</p>
        <p>第二条 <span></span>本保险合同适用于中华人民共和国境内（不包括港、澳、台地区）投标当事人参与的招标投标项目。</p>
        <p>&nbsp</p>
        <p>第三条 <span></span>凡在中华人民共和国境内（不含港、澳、台地区）依法设立，参与项目投标活动的企业可作为本保险合同的投保人。招标投标活动中，招标方（企业或其他组织）可作为本保险合同的被保险人。</p>
        <p>&nbsp</p>
        <p class="min_title">保险责任</p>
        <p> 第四条 <span></span>在保险期间内，投保人在参与保险单载明的招标项目竞标过程中，发生下列情形之一的，被保险人可向保险人提出索赔，保险人按照本保险合同的约定对被保险人承担赔偿责任。</p>
        <p>（一）投保人在投标有效期内违反招标文件的有关规定擅自修改投标文件；</p>
        <p>（二）在招标文件规定的投标时间截止后撤销投标文件；</p>
        <p>（三）投保人收到被保险人发出的中标通知，未能或拒绝在有效期内签订合同；</p>
        <p>（四）投保人收到被保险人发出的中标通知，未能或拒绝在规定期限内根据招标文件要求提供履约保证金/银行保函/履约保证保险；</p>
        <p>（五）中标后，因投保人的违法行为导致中标被依法确认无效；</p>
        <p>（六）出现法律、法规、招标文件规定的没收保证金的其他情形。</p>
        <p>&nbsp</p>
        <p class="min_title">责任免除</p>
        <p class="bold">第五条<span></span> 存在以下情形之一的，保险人不负责赔偿：</p>
        <p class="bold">（一）被保险人与投保人或其他人串通，虚构基础交易；</p>
        <p class="bold">（二）被保险人提交的第三方单据系伪造或内容虚假；</p>
        <p class="bold">（三）法院判决或仲裁裁决认定投保人没有付款或赔偿责任；</p>
        <p class="bold">（四）被保险人明知其没有付款请求权仍滥用该权利的其他情形。</p>
        <p>&nbsp</p>
        <p class="bold">第六条 <span></span>下列原因造成的损失、费用和责任，保险人不负责赔偿：</p>
        <p class="bold">（一）战争、敌对行为、军事行动、武装冲突、罢工、暴动、民众骚乱、恐怖活动；</p>
        <p class="bold">（二）核爆炸、核污染及其他放射性污染；</p>
        <p class="bold">（三）地震、海啸、水灾、火灾、暴风或其他不可抗拒的自然灾害。</p>
        <p>&nbsp</p>
        <p class="bold">第七条 <span></span>对下列损失、费用和责任，保险人不负责赔偿：</p>
        <p class="bold">（一）被保险人的间接损失；</p>
        <p class="bold">（二）根据招标文件应由被保险人承担的责任；</p>
        <p class="bold">（三）罚款、罚金及惩罚性赔偿。</p>
        <p>&nbsp</p>
        <p class="min_title">保险金额</p>
        <p>第八条 <span></span>保险金额是保险人承担赔偿责任的最高限额，由投保人和保险人依据招标文件中相关规定协商确定，并在保险单中载明。</p>
        <p>&nbsp</p>
        <p class="min_title">保险期间</p>
        <p>第九条 <span></span>保险期间由投保人与保险人依据招标文件有关约定协商确定，具体以保险单载明的约定时间为准，但最长不超过一年。</p>
        <p>&nbsp</p>
        <p class="min_title">保险人义务</p>
        <p>第十条<span></span>
          订立保险合同时，如采用保险人提供的格式条款的，保险人向投保人提供的投保单应当附格式条款，保险人应当向投保人说明保险合同的内容。对保险合同中免除保险人责任的条款，保险人在订立合同时应当在投保单、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人作出明确说明；未作提示或者明确说明的，该条款不产生效力。
        </p>
        <p>&nbsp</p>
        <p> 第十一条 <span></span>投保人提出保险要求，经保险人同意承保，保险合同成立，保险人应当及时向投保人签发保险单或其他保险凭证，并向被保险人通知保险单或其他保险凭证信息。</p>
        <p>&nbsp</p>
        <p>第十二条<span></span> 保险人收到被保险人提交的索赔申请文件后，应当从交单次日起的五个工作日内确定被保险人提供的有关索赔证明和资料是否完整，如不完整应一次性地通知被保险人补充提供。</p>
        <p>&nbsp</p>
        <p class="min_title">投保人、被保险人义务</p>
        <p>第十三条 <span></span>投保人应履行如实告知义务，如实回答保险人就有关情况提出的询问，并如实填写投保单。</p>
        <p>&nbsp</p>
        <p> 第十四条 <span></span> 投保人应在保险合同成立时一次性足额交付保费。<span class="bold" style="margin: 0;">投保人未按约定交纳保险费，保险合同不生效。</span></p>
        <p>&nbsp</p>
        <p>第十五条 <span></span> 投保人、被保险人有义务协助保险人或保险人委托的第三方核查与本保险合同有关的招标投标文件、单证以及往来函电等资料。</p>
        <p>&nbsp</p>
        <p>第十六条 <span></span> 被保险人在保险单生效后，招标条件发生变化且增加保险人责任的，应当及时通知投保人办理保险单批改手续。投保人应该按要求向保险人申请批改保单，否则保险人有权拒绝承担赔偿责任。</p>
        <p>&nbsp</p>
        <p> 第十七条 <span></span>被保险人知道保险事故发生后，应当及时通知保险人。<span
            class="bold" style="margin: 0;">故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担赔偿或者给付保险金的责任，</span>但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。
        </p>
        <p>&nbsp</p>
        <p class="min_title">赔偿处理</p>
        <p> 第十八条<span></span> 被保险人申请赔偿时，应向保险人提供下列索赔文件：</p>
        <p>（一） 索赔申请书，含对该索赔的声明、说明及意见；</p>
        <p>（二） 招投标文件；</p>
        <p>（三） 其他所能提供的与确认保险事故的性质、原因、损失程度等有关的证明和资料（如有）。</p>
        <p>被保险人未履行前款约定的索赔材料提供义务，导致保险人无法核实损失情况的，保险人对无法核实部分不承担赔偿责任。</p>
        <p>&nbsp</p>
        <p>第十九条<span></span> 保险人收到被保险人提交的相符的完整索赔文件后，应当从次日起的五个工作日内完成是否属于保险责任的核定。</p>
        <p>（一）对属于保险责任的，保险人应当在与被保险人达成赔偿保险金的协议后十日内，向被保险人履行赔偿义务；</p>
        <p>（二）对不属于保险责任的，保险人应当自做出核定之日起三日内，向被保险人发出拒绝赔偿通知书。</p>
        <p>第二十条<span></span> 发生保险责任范围内的损失，保险人自向被保险人赔偿保险金之日起，在赔偿金额范围内有权向投保人请求赔偿，被保险人就此应当向保险人提供必要的文件和协助。</p>
        <p>争议处理和法律适用</p>
        <p>&nbsp</p>
        <p> 第二十一条 <span></span> 因履行本保险合同发生的争议，由当事人协商解决。协商不成的，提交保险单载明的仲裁机构仲裁；保险单未载明仲裁机构且争议发生后未达成仲裁协议的，可依法向中华人民共和国人民法院起诉。
        </p>
        <p>&nbsp</p>
        <p>第二十二条 <span></span> 本保险合同的争议处理适用保险单载明的法律，保险单未约定的则适用保险人所在地法律。</p>
        <p>&nbsp</p>
        <p class="min_title">其他规定</p>
        <p>第二十三条<span></span> 保险人依照本保险合同约定向被保险人支付保险赔偿金后，保险责任自行终止。</p>
        <p>&nbsp</p>
        <p> 第二十四条<span></span> 除投保人与保险人另有约定，保险责任开始前，投保人要求解除保险合同的，保险人可以退还全额保险费，保险责任开始后，保险合同当事人不得解除保险合同。</p>
        <p>&nbsp</p>
        <p class="min_title">释 义</p>
        <p>第二十五条 <span></span> 本保险合同涉及下列术语时，适用下列释义：</p>
        <p>（一）【投标有效期】指为保证招标方有足够的时间在开标后完成评标、定标、合同签订等工作而要求投保人提交的投标文件在一定时间内保持有效的期限，该期限由招标方在招标文中载明，从提交招标文件的截止之日起算。</p>
        <p>（二）【履约保证金】指在招标投标活动中，招标方为督促中标人履行合同，在招标文件中要求中标人以适当的格式或金额采用现金、银行保函、履约保证保险等形式提供的担保。</p>
      </div>
      <!-- 特别约定 -->
      <div class="pop_content" v-show="clauseIndex == 3">
        <h3 style="text-align: center">
          特别约定
        </h3>
        <p> 本保函在投标有效期内保持有效。要求我方承担保证责任的通知应在投标有效期内送达我方。</p>
        <p>1.投标人名称：***；</p>
        <p> 2.项目名称：***；招标编号：****；</p>
        <p> 3.保证金金额：****元；</p>
        <p>4.投标保证保险的有效期：** 天。</p>
        <p>本保险合同项下，若投保人中标则保险期间终止日期为投保人与招标方签定合同之日；若投保人未中标则保险期间终止日期为招标结果公示结束之日，若招标顺延则本保单有效期自动顺延，最长不超过一年。</p>
      </div>
      <!-- 投保声明 -->
      <div class="pop_content" v-show="clauseIndex == 4">
        <h3 style="text-align: center">
          大家财产保险有限责任公司石家庄中心支公司投标保证保险投保声明
        </h3>
        <p>1.本人已完整阅读并了解投保须知及投保险种的保险条款，尤其是对其中免除保险人责任的条款或约定（包括但不限于责任免除、投保人被保险人义务、保险金申请与给付等），本人已充分理解并接受上述内容，同意以此作为订立保险合同的依据。
        </p>
        <p> 2.投保时，投保人已就该产品的保障内容以及保险金额等向被保险人或其监护人进行了明确说明，并已征得其同意投保本产品。</p>
        <p> 3.投保单中所填写的内容均属实，如有隐瞒或不实告知，保险人有权根据《中华人民共和国保险法》第十六条的规定解除保险合同，并对合同解除前发生的任何事故，保险人可不承担任何责任。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    clauseIndex: {
      typeof: Number,
      default: 1,
    },
    radio: {
      typeof: String,
      default: '2',
    },
  },
  created() { },
  mounted() { },
  methods: {},
}
</script>

<style lang='less' scoped>
@media screen and (max-width:1000px) {
  h3{
    font-size: 35px;
  }
  .pop_content {
    p {
      text-indent: 2em;

      span {
        margin-left: 20px;
      }
    }

    .bold {
      font-weight: bold;
    }

    .min_title {
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      line-height: 66px;
    }
  }
}
@media screen and (min-width:1000px) {
  .pop_content {
    p {
      text-indent: 2em;

      span {
        margin-left: 20PX;
      }
    }

    .bold {
      font-weight: bold;
    }

    .min_title {
      font-size: 14PX;
      font-weight: bold;
      text-align: center;
      line-height: 26PX;
    }
  }
}
</style>